import React from 'react'
import { loc } from '../../../core/utils'

const BreadcrumbItem = ({ title, isActive }) => {
  return (
    <li className={isActive ? "is-active" : ""}>
      <span className={isActive ? "is-page-active" : ""}>
        {loc(title)}
      </span>
    </li>
  )
}

export default BreadcrumbItem
